// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1988":"710752585970b269","2291":"854908841a624fbe","3744":"f61a2e46e2bf3efa"}[chunkId] + ".js";
};